module.exports = __webpack_public_path__ + "static/home_screenshot-a75e090beab400f96c23bd0424d555ce.png";